import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'antd'
import css from './filter.css'

const PracticeSearchBar = ({
  searchString,
  updateSearchString,
}) => {
  const onInputChange = ({ target: { value } }) => updateSearchString(value)
  return (
    <div className={css.searchContainer}>
      <Input
        size="large"
        placeholder="Search practices by name, ID, or phone number"
        defaultValue=""
        value={searchString}
        onChange={onInputChange}
      />
    </div>
  )
}

PracticeSearchBar.propTypes = {
  searchString: PropTypes.string.isRequired,
  updateSearchString: PropTypes.func.isRequired,
}

export default PracticeSearchBar



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/PracticeSearchBar.js